export const menuClassMap = {
  mobile: "xl:hidden",
  desktop: "hidden xl:flex",
};

export type Menu = keyof typeof menuClassMap;
